import { render, staticRenderFns } from "./GameLive.vue?vue&type=template&id=c796a1bc&"
import script from "./GameLive.vue?vue&type=script&lang=js&"
export * from "./GameLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports